import React from "react";
import HouseRulesComponents from "../../components/HouseRulesComponent/HouseRulesComponen.jsx";
import Support from "../../components/SuportComponent/support.js";

function HouseRules() {
  return (
    <div>
      <HouseRulesComponents />
      <Support />
    </div>
  );
}

export default HouseRules;
